module.exports = (function() {
	$("body").tooltip({
		selector: '[data-toggle="tooltip"]'
	});
})


/** WEBPACK FOOTER **
 ** ./src/lib/scripts.js
 **/